import { KeyboardEventHandler, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

// components
import UplusButton from 'components/common/button/UplusButton';
import LoginInput from 'components/login/LoginInput';
// hooks & utils
import { useLoginMutation } from 'hooks/mutations/user';
import CoreCheckBox from 'shared/CoreCheckBox';
import { getCookie, removeCookie, setCookie } from 'utils/cookies';

import { Body, BodyFooter, BodyTitle, ForgotText, InputForm, RememberBox } from './style';

const Login = () => {
	// 자동로그인 체크 여부
	const [checked, setChecked] = useState(false);
	/** 체크 박스 클릭 시 동작 */
	const setCheckBox = () => {
		if (checked) setChecked(false);
		else if (!checked) setChecked(true);
	};

	// ref
	const id_ref = useRef<HTMLInputElement>(null);
	const pwd_ref = useRef<HTMLInputElement>(null);
	const btn_ref = useRef<HTMLButtonElement>(null);

	// mutations
	const { mutate: loginMutate, isPending: login_loading } = useLoginMutation(checked);

	// cookie에 id, pwd가 있을때 설정
	useEffect(() => {
		if (getCookie('id') && getCookie('pwd')) {
			setChecked(true);
			getCookie('id') && id_ref.current && (id_ref.current.value = getCookie('id'));
			getCookie('pwd') && pwd_ref.current && (pwd_ref.current.value = getCookie('pwd'));
		}
	}, []);

	/** 로그인 클릭 시 동작 */
	const clickLogin = () => {
		if (id_ref.current === null || pwd_ref.current === null) return;

		if (checked) {
			setCookie('id', id_ref.current.value);
			setCookie('pwd', pwd_ref.current.value);
		} else {
			removeCookie('id');
			removeCookie('pwd');
		}

		loginMutate({
			username: id_ref.current?.value,
			password: pwd_ref.current?.value,
		});
	};

	const enterEvent: KeyboardEventHandler<HTMLInputElement> = (e) => {
		if (e.key !== 'Enter' || btn_ref.current === null) return;
		btn_ref.current.click();
	};

	return (
		<Body>
			<BodyTitle>로그인</BodyTitle>

			<InputForm>
				<LoginInput
					_placeholder="ID"
					input_id="login-id"
					_ref={id_ref}
					_onKeyDown={enterEvent}
				/>
				<LoginInput
					type="password"
					_placeholder="Password"
					input_id="login-pwd"
					_ref={pwd_ref}
					_onKeyDown={enterEvent}
				/>
			</InputForm>

			<RememberBox checked={checked}>
				<CoreCheckBox
					check_type="common"
					value="아이디 기억하기"
					name="remember-id-input"
					checked_value={checked}
					_onMouseDown={setCheckBox}
				/>
			</RememberBox>

			<BodyFooter>
				<UplusButton
					size="large"
					style_type="filled"
					text="로그인"
					_ref={btn_ref}
					_onClick={clickLogin}
					is_loading={login_loading}
				/>
				<Link to="/login/password_help">
					<ForgotText>계정 문의</ForgotText>
				</Link>
			</BodyFooter>
		</Body>
	);
};

export default Login;
